import API, { APIResponse } from '../../../lib/commons/api'
import {
  Program,
  ProgramManagementDeltaBatchRequest,
  ProgramManagementResponse,
} from '../../../view/pages/ProgramManagement/programManagement'

type ReferencedValue = {
  uuid: string
  code: string
  name: string
}

export const fetchProgramList = async (): Promise<Program[]> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/programs/referenced_values'
  )
  const values = response.json as ReferencedValue[]
  return values.map(v => ({
    uuid: v.uuid,
    code: v.code,
    displayName: v.name,
  }))
}

export const fetchProgramManagementData = async (
  programUuid: string
): Promise<ProgramManagementResponse> => {
  const response = await API.functional.request(
    'GET',
    `/api/v1/programs/${programUuid}/reports`
  )
  return response.json as ProgramManagementResponse
}

export const saveProgramManagementDeltaBatch = (
  programUuid: string,
  request: ProgramManagementDeltaBatchRequest
): Promise<APIResponse> =>
  API.functional.request(
    'POST',
    `/api/v1/programs/${programUuid}/management/delta/batch`,
    request
  )

export const fetchProjectReports = async (
  projectUuids: string[]
): Promise<ProgramManagementResponse[]> => {
  const response = await API.functional.request(
    'POST',
    '/api/v1/programs/management/projects/reports',
    { projectUuids }
  )
  return response.json as ProgramManagementResponse[]
}
